import { o_global } from "@gr-common/body/namespaces";
const grScope = o_global.debug.scope("gr");
export {
  grScope
};
